'use client';

import Image from 'next/image';
import Link from 'next/link';
import { imgLoader } from '~/shared/lib';
import type {
    HomePageImageGetPayload,
    HomePageMobileImageGetPayload,
} from '../../../../../../packages/db/dist/src/generated/internal/prismaNamespace';

type HomePageImageWithImage = HomePageImageGetPayload<{
    include: { image: true };
}>;

type HomePageMobileImageWithImage = HomePageMobileImageGetPayload<{
    include: { image: true };
}>;

type CoverProps = {
    images?: HomePageImageWithImage[] | HomePageMobileImageWithImage[];
};

export const Cover = ({ images }: CoverProps) => {
    if (!images) return null;

    return (
        <>
            {images.map(
                ({ image, link }) =>
                    !!image &&
                    !!image.key && (
                        <Link
                            key={image.key}
                            href={link ?? '/'}
                            className={'relative h-full flex-1 cursor-default md:cursor-pointer'}
                        >
                            <Image
                                key={image.key}
                                loader={imgLoader({ src: image.key, width: image.width, quality: 75 })}
                                src={image.key}
                                placeholder={'blur'}
                                blurDataURL={image.lqip ?? undefined}
                                className={'h-full flex-1 object-cover'}
                                fill
                                sizes={
                                    '(max-width: 768px) 384px, (max-width: 1024px) 512px, (max-width: 1536px) 768px, 1024px'
                                }
                                alt={''}
                            />
                        </Link>
                    ),
            )}
        </>
    );
};
